"use client";

import { useEffect, useState } from "react";

export default function DynamicFavicon({ theme }: { theme: string }) {
  const [faviconUrl, setFaviconUrl] = useState("/assets/favicon/classic/favicon.ico");

  useEffect(() => {
    setFaviconUrl(`/assets/favicon/${theme}/favicon.ico`);
  }, [theme]);

  return (
    <link
      rel="icon"
      type="image/x-icon"
      href={faviconUrl}
    />
  );
}
